import ticketIcon from "@/assets/img/raffle/ticket.png";

export default {
  name: "raffle-block",
  props: {
    raffle: {
      type: Object,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infoOpen: false,
    };
  },
  computed: {
    state() {
      if (this.raffle.isMax) return "max";

      return this.raffle.tickets > 0 ? "tickets" : "zero";
    },
    icon() {
      return this.raffle.icon || ticketIcon;
    },
    step() {
      return this.money(this.raffle.step);
    },
    maxTickets() {
      return this.raffle.maxTickets;
    },
    ticketsLabel() {
      return `${this.raffle.tickets} ${this.ticketsWord(this.raffle.tickets)}`;
    },
    maxLabel() {
      return `${this.maxTickets} ${this.ticketsWord(this.maxTickets)}`;
    },
    left() {
      return this.money(this.raffle.leftToNext);
    },
    from() {
      const { tickets, step, amount } = this.raffle;

      return this.money(tickets > 0 ? tickets * step : amount);
    },
    to() {
      const { tickets, step } = this.raffle;

      return this.money((tickets + 1) * step);
    },
    progress() {
      const { step, leftToNext } = this.raffle;
      if (!step || leftToNext == null) return 0;

      return Math.min(100, Math.max(0, ((step - leftToNext) / step) * 100));
    },
    rules() {
      return [
        "Акція діє з 1 по 25 жовтня.",
        `1 квиток за кожні повні ${this.step} грн в одному чеку.`,
        `Максимум — ${this.maxLabel} на одного учасника за весь період акції.`,
        "Квитки рахуються від фінальної суми чека після застосування знижок і промокодів.",
        "Суми різних замовлень між собою не сумуються.",
      ];
    },
  },
  mounted() {
    document.addEventListener("click", this.closeInfo);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeInfo);
  },
  methods: {
    money(value) {
      return Math.round(Number(value) || 0).toLocaleString("uk-UA");
    },
    ticketsWord(count) {
      const mod10 = count % 10;
      const mod100 = count % 100;
      if (mod10 === 1 && mod100 !== 11) return "квиток";
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return "квитки";

      return "квитків";
    },
    closeInfo(event) {
      if (this.$refs.info && !this.$refs.info.contains(event.target)) {
        this.infoOpen = false;
      }
    },
  },
};
